import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { AuthenticationService } from '../../authentication.service';
import { MakingDataService } from './making-data.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  constructor(private mds:MakingDataService,private http: HttpClient ,private auth:AuthenticationService, private token:TokenService) { }
  profileImageUrl:any;
  codeValueTechObj :any= {};
  accountImageUrl:any;
  accInfo:any = {}
  codeValueShowObj :any= {};
  public editorValue:any;
  selectedModuleForCommonWorkFlow:any;
  //httpUrl="http://localhost:30001";
  // httpUrl="http://localhost:3000";
  httpUrl = this.auth.httpUrl;
  // httpUrl="https://vdaerp.pcstech.com:3000";
  dateFormatChange(date:any) {
    var datear1 = date.split('T')[0]
    var datearr = datear1.split("-")
    return datearr[2] + '/' + datearr[1] + '/' + datearr[0]
  }
  changeLanguage() {
    if (this.language_cd == null || this.language_cd == undefined) {
      this.language_cd = 'ENG'
    }
    console.log(this.language_cd)
  }

  allLanguage :any= []
  allLableShowObj:any = {};
  allLabel :any= [];
  language_cd:any='ENG';
  async getFields(obj :any) {
    const res = await this.http.get<any>(this.httpUrl + '/metadata/fields/getfields' + obj ).toPromise().then(res => {
      return res;

    });
    return res;
  }
  async getAllUsersForAllModules(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/user/getAllUsersForAllModules' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getCodeValue(b_acct_id:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/metadata/codeValue/getCodeValues' + b_acct_id ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  // async getCurrentLegalEntity(b_acct_id:any) {
  //   const resp = await this.http.get<any>(this.httpUrl + '/systemdata/legalentity/getcurrentlegalentity' +b_acct_id ).toPromise().then(async res => {
  //     return await this.mds.dataD(res)
  //   });
  //   return resp;
  // }
  async getCurrentLegalEntity(b_acct_id:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/systemdata/legalentity/getcurrentlegalentity'+ JSON.stringify({}),{headers: new HttpHeaders().append('data',await this.mds.dataE(b_acct_id))}).toPromise().then( async  res => {
      return  await  this.mds.dataD(res);
    });
    return resp;
  }

  async getAccountModules(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getAccountModules' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }






  async getResource(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getcurrentresource' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getApprovalroles(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getApprovalroles' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getModules(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getmodules' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getAdminCodeValue(b_acct_id:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/codevalue/getCodeValue' + b_acct_id ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async createLegalEntity(obj :any) {
    const res = await this.http.post<any>(this.httpUrl + '/systemdata/legalentity/createindentity', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async createAccount(obj :any) {
    const res = await this.http.post<any>(this.httpUrl + '/systemdata/signup/signup', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async createRole(obj :any) {
    const res = await this.http.post<any>(this.httpUrl + '/admin/role/createrole', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async createUser(obj :any) {
    const res = await this.http.post<any>(this.httpUrl + '/admin/user/createuser', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async getCurrentrole(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getcurrentroles' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  // async getCurrentUser(obj :any) {
  //   const resp = await this.http.get<any>(this.httpUrl +'/admin/user/getcurrentuser'+obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }

  // ===============MD

  async getuserforrolemapping(obj :any) {
    const res = await this.http.get<any>(this.httpUrl + '/md/user/getuserforrolemapping' + obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async getuserformodulerolemapping(obj :any) {
    const res = await this.http.get<any>(this.httpUrl + '/md/user/getuserformodulerolemapping' + obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }

  //start deepankar RoleWise User Service
  async getUserRoleWise(obj :any) {
    const res = await this.http.get<any>(this.httpUrl + '/md/user/getUserRoleWise' + obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
//end
  async getuseridforhier(obj :any) {
    const res = await this.http.get<any>(this.httpUrl + '/md/user/getuseridforhier' + obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async createMdRole(obj :any) {
    const res = await this.http.post<any>(this.httpUrl + '/md/role/createrole', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async deleteRole(obj :any) {
    const res = await this.http.put<any>(this.httpUrl + '/md/role/inactiverole', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async updateRole(obj :any) {
    const res = await this.http.put<any>(this.httpUrl + '/md/role/updaterole', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  // async getCurrentMdRole(obj :any) {
  //   const resp = await this.http.get<any>(this.httpUrl +'/md/role/getcurrentroles'+JSON.stringify({}),{headers: new HttpHeaders().append('data',await this.mds.dataE(obj))}).toPromise().then(async res => {
  //     return  await  this.mds.dataD(res);
  //   });
  //   return resp;
  // }
  async getCurrentMdRole(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl +'/md/role/getcurrentroles'+obj).toPromise().then(async res => {
      return  res
    });
    return resp;
  }

  async createNewWorkflow(obj :any) {
    const resp = await this.http.post<any>(this.httpUrl + '/metadata/workflow/createNewWorkflow', obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateNewWorkflow(obj :any) {
    const resp = await this.http.put<any>(this.httpUrl + '/metadata/workflow/updateNewWorkflow', obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getWorkflows(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/metadata/workflow/getWorkflows' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getdistinctDocumentWorkflows(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/metadata/workflow/getdistinctDocumentWorkflows' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  async getMdResource(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/resource/getcurrentresource' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getMdModules(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getmodules' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async AllModules(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getAccountModules' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getCurrentMdUser(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/user/getcurrentuser' +  JSON.stringify({}),{headers: new HttpHeaders().append('data',await this.mds.dataE(obj))}   ).toPromise().then(async res => {
      return await this.mds.dataD(res);
    });
    return resp;
  }
  // async getAllUsersForAllModules(obj :any) {
  //   const resp = await this.http.get<any>(this.httpUrl + '/md/user/getAllUsersForAllModules' + obj   ).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  async createMdUser(obj :any) {
    const res = await this.http.post<any>(this.httpUrl + '/md/user/createuser', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async getCurrentMdrole(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getcurrentroles' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteUser_MD(obj :any) {
    const res = await this.http.put<any>(this.httpUrl + '/md/user/inactiveuser', obj   ).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async getcurrentroleswithresources(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getroleswithresources' + obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }




  async insertroleprint(obj :any) {
    const resp = await this.http.post<any>(this.httpUrl + '/emb/info/role_print/insertroleprint' , obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getroleprint(obj :any) {
    const resp = await this.http.get<any>(this.httpUrl + '/emb/info/role_print/getroleprint'+obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateroleprint(obj :any) {
    const resp = await this.http.put<any>(this.httpUrl + '/emb/info/role_print/updateroleprint', obj   ).toPromise().then(res => {
      return res;
    });
    return resp;
  }


    //header info


}


